import type { FormattedTranslationKey } from '../../../../i18n';

export const MAX_QUESTIONS = 5;
export const MAX_QUESTION_LENGTH = 90;

export const SECTION_ID = 'screening_questions';

export const SUGGESTED_QUESTION_TRANSLATION_KEYS: FormattedTranslationKey[] = [
    'sections.screening_questions.suggestions.similar_projects',
    'sections.screening_questions.suggestions.approach',
    'sections.screening_questions.suggestions.updates',
    'sections.screening_questions.suggestions.skills',
    'sections.screening_questions.suggestions.support',
];
